export default __webpack_public_path__ + "static/media/client-05.faa35ad0.svg";